import React from "react";
import ProfileCore from "../../shared/profile/ProfileCore";
import SeekerProfile from "../../components/Profile/SeekerProfile";

export default function ProfileSeeker() {
    return (
        <ProfileCore
            renderContent={(profileData, refreshProfile) => (
                <SeekerProfile data={profileData} refreshProfile={refreshProfile} />
            )}
        />
    );
}
